export default "__VITE_ASSET__BxfLeQk1__";